import Icon from '../components/Icon.vue'

Icon.register({
  'dice-one': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M384 32H64C28.6 32 0 60.6 0 96V416C0 451.4 28.6 480 64 480H384C419.4 480 448 451.4 448 416V96C448 60.6 419.4 32 384 32zM224 288C206.3 288 192 273.7 192 256S206.3 224 224 224 256 238.3 256 256 241.7 288 224 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice-one.js
// module id = eb64
// module chunks = 144